var blogCategory = {

	useMasonry: false,

	init: function () {

		$('.m-blog-category:not(.js-category-done)').each(function () {
			var wrapper = $(this);
			var grid = wrapper.find('.js-grid');
			var form = wrapper.closest('form');
			var pageInput = form.find('input[name="page"]');
			var more = wrapper.find('.js-show-more');
			var error = wrapper.find('.js-grid-error');

			// masonry
			if (blogCategory.useMasonry) {
				setTimeout(function () {
					grid.masonry({
						itemSelector: '.js-grid-item',
						columnWidth: '.grid-sizer',
						transitionDuration: 0,
						percentPosition: true
					});
				}, 200);
			}

			var _load = function (clear) {
				// change text
				more.text('Loading...');
				// show loader
				popups.loader();
				// ajax
				$.ajax({
					url: '/blog/posts/json/',
					data: form.serialize(),
					cache: false,
					success: function (response) {
						// hide error
						error.hide();
						// check any posts or limit
						if (!response.length) {
							// hide button
							more.hide();
							// show alert
							popups.confirm('Complete', 'There are no more articles to show.', '', true);
							// show error
							if (pageInput.val() == 1) {
								error.show();
							}							
						}
						else if (response.length < wrapper.attr('data-per-page')) {
							// hide button
							more.hide();
						}
						else {
							// show button
							more.show().text('Show more');
						}
						// clear
						if (clear) {
							// remove items
							wrapper.find('.js-blog-posts .js-grid-item').remove();
						}
						// history
						if (Modernizr.history) {
							history.replaceState(null, null, '?' + form.serialize());
						}
						// add new posts
						for (var i = 0; i < response.length; i++) {
							var item = $(tmp.render(response[i]));
							if (blogCategory.useMasonry) {
								grid.append(item).masonry('appended', item);
							}
							else {
								wrapper.find('.js-blog-posts').append(item);
							}
						}
						// reset masonry
						setTimeout(function () {
							// reset masonry
							if (blogCategory.useMasonry) {
								grid.masonry('layout');
							}
							// hide loader
							popups.loader(true, !response.length ? true : false);
							popups.fadeClick = true;
							popups.allow = true;
						}, blogCategory.useMasonry ? 200 : 10);
					},
					error: function (e) {
						// hide loader
						popups.loader(true, true);
						popups.fadeClick = true;
						popups.allow = true;
						// show notice
						popups.confirm('Error', 'Sorry, there was an error (' + e.statusText.toLowerCase() + '). Please try again.', '', true);						
					},
					complete: function () {
						// change text
						more.text('Show more');
					}
				});
			}

			// filter
			form.find('input[name="category"]').on('change', function () {
				// set page
				pageInput.val(1);
				// analytics
				site.analytics.track('Blog Filter', 'Click', form.serialize());
				// load
				_load(true);
			});

			// template
			var tmp = $('#blogCategoryPostTemplate').html();
			tmp = Hogan.compile(tmp);

			// show more
			more.off('click').on('click', function () {
				// set page + 1
				pageInput.val(parseInt(pageInput.val(), 10) + 1);
				// analytics
				site.analytics.track('Blog Show More', 'Click', form.serialize());
				// load
				_load(false);
				return false;
			});

			// done
			wrapper.addClass('js-category-done');
		});

	}

};

$(function () {
	blogCategory.init();
	site.doc.ajaxComplete(function () {
		blogCategory.init();
	});
});